import React from "react";
import ImageModalCloseX from "components/utility/images/ImageModalCloseX";
import { DDXModal } from "components/ddx-modal/DDXModal";

const VideoModal = ({ showClose, showModal, setShowModal, vid }) => {
	const handleCloseModal = () => {
		setShowModal(false);
	};

	return (
		<DDXModal className="video-modal" showModal={showModal} handleCloseModal={handleCloseModal}>
			{/* The video container is using vh and vw to allow reszing. 
					DDXModal handles clicks outside the component but the video container goes around the actual content a fair bit.
					This allows the experience to stay consistent when clicking outside the video */}
			<div className="video-modal-content-container" role="none" onClick={handleCloseModal}>
				<div className="video-modal-content">
					{showClose && (
						<button
							aria-label="close"
							className="video-modal-close-button"
							onClick={handleCloseModal}
							tabIndex={0}
						>
							<ImageModalCloseX />
						</button>
					)}
					<iframe
						className="video-modal-iframe"
						width="100%"
						height="100%"
						title="Video Modal"
						src={vid}
						allowFullScreen
					/>
				</div>
			</div>
		</DDXModal>
	);
};

export default VideoModal;
